import type { RouteLocationNormalizedLoaded } from 'vue-router';

/**
 * True when `route` is a shop PDP (`/{locale}/shop/{urlKey}`).
 * When `expectedUrlKey` is set, the param must match.
 */
export function isShopPdpRoute(
  route: Pick<RouteLocationNormalizedLoaded, 'path' | 'params'>,
  expectedUrlKey?: string
): boolean {
  const segments = route.path.split('/').filter(Boolean);
  if (segments[1]?.toLowerCase() !== 'shop') {
    return false;
  }

  const urlKeyParam = route.params.urlKey;
  const currentUrlKey = Array.isArray(urlKeyParam)
    ? urlKeyParam[0]
    : urlKeyParam;

  if (!currentUrlKey) {
    return false;
  }

  if (expectedUrlKey !== undefined) {
    return String(currentUrlKey) === expectedUrlKey;
  }

  return true;
}
